var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgListGray600Icon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2222 2.7H15.3333V1H13.5556V2.7H6.44444V1H4.66667V2.7H3.77778C2.8 2.7 2 3.465 2 4.4V16.3C2 16.7509 2.1873 17.1833 2.5207 17.5021C2.8541 17.8209 3.30628 18 3.77778 18H16.2222C17.2089 18 18 17.2435 18 16.3V4.4C18 3.94913 17.8127 3.51673 17.4793 3.19792C17.1459 2.87911 16.6937 2.7 16.2222 2.7ZM16.2222 16.3H3.77778V7.8H16.2222V16.3ZM3.77778 6.1V4.4H16.2222V6.1H3.77778ZM5.55556 9.5H14.4444V11.2H5.55556V9.5ZM5.55556 12.9H11.7778V14.6H5.55556V12.9Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListGray600Icon);
export default __webpack_public_path__ + "static/media/list_gray600_icon.24c9ba5b3b13e9efb8a5b3e2202982df.svg";
export { ForwardRef as ReactComponent };